/**
 * Created by tong on 2018/1/23.
 */
import React from 'react';

class InvoiceManagement extends React.Component {
  render() {
    return <div className='dms-body'>
        {this.props.children}
    </div>
  }
}
export default InvoiceManagement;


// WEBPACK FOOTER //
// ./src/routes/invoiceManagement/index.js